"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ResourceIconWithColor = void 0;
const react_1 = __importDefault(require("react"));
const ConfigResource_1 = require("../../models/config/ConfigResource");
const IconLabel_1 = require("../icons/IconLabel");
/** Small component for the colored resource icon and resource title. */
const ResourceIconWithColor = (props) => {
    var _a;
    let iconColor;
    let title;
    if (props.resource instanceof ConfigResource_1.ConfigResource) {
        iconColor = props.resource.color;
        title = props.resource.resourceItem.title;
    }
    else {
        iconColor = "#000";
        title = props.resource;
    }
    return (react_1.default.createElement("span", { className: "text-nowrap " + ((_a = props.className) !== null && _a !== void 0 ? _a : "") },
        react_1.default.createElement(IconLabel_1.IconLabel, { style: { color: `${iconColor}` } }),
        !props.noTitle && react_1.default.createElement(react_1.default.Fragment, null,
            " ",
            title)));
};
exports.ResourceIconWithColor = ResourceIconWithColor;
